/* eslint-disable react-hooks/rules-of-hooks */
import { useDispatch, useSelector } from 'react-redux';
import {
  companyWorkspaceAccessesSelector,
  isLoadingWorkspaceAccessesSelector,
  userRoleSelector
} from '../redux/selectors';
import { useEffect } from 'react';
import { TAccessItem } from 'src/interfaces/workspacesReduxShapes';
import { getWorkspaceAccesses } from 'src/redux/actions/workspacesActions';
import { ACCOUNT_ROLES } from 'src/constants/globalConstants';
import { useParams } from 'react-router-dom';

export const getCompanyWorkspaceAccessesHook = (): {
  accesses: TAccessItem[];
  isLoading: boolean;
} => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useDispatch();
  const accesses = useSelector(companyWorkspaceAccessesSelector);
  const isLoading = useSelector(isLoadingWorkspaceAccessesSelector);
  const userRole = useSelector(userRoleSelector);

  useEffect(() => {
    if (userRole !== ACCOUNT_ROLES.COMPANY) return;

    dispatch(getWorkspaceAccesses({ workspaceId: id }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userRole]);

  return { accesses, isLoading };
};
